export const REPORT_STATUSES = {
  unknown: "unknown",
  initialised: "initialised",
  queued: "queued",
  generating: "generating",
  failed: "failed",
  complete: "complete"
}
